import React from 'react';
import cn from 'classnames';
import { Icon } from 'antd';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Admin.css';
import Navigation from '../Navigation/Admin';

class Header extends React.Component {
  static propTypes = {
    user: PropTypes.shape().isRequired,
    enabledModel: PropTypes.array.isRequired,
    collapsed: PropTypes.bool.isRequired,
    triggerCollapse: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
  };
  render() {
    const { lang, triggerCollapse, collapsed, enabledModel } = this.props;
    return (
      <div className={cn(s.wrap, 'header-box')}>
        <div className={s.container}>
          <div
            className={s.collapse}
            onClick={() => triggerCollapse(!collapsed)}
          >
            <Icon type={collapsed ? 'menu-unfold' : 'menu-fold'} />
          </div>
          <Navigation
            lang={lang}
            user={this.props.user || {}}
            enabledModel={enabledModel}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Header);
